import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconMolecule = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M21.725 2.60061C22.0837 2.80771 22.2066 3.26641 21.9995 3.62513L19.8884 7.28168C19.7544 7.51373 19.5068 7.65668 19.2389 7.65668H15.4497L13.7716 10.5632L15.6662 13.8449C15.8002 14.0769 15.8002 14.3628 15.6662 14.5949L13.5551 18.2514C13.4211 18.4835 13.1736 18.6264 12.9056 18.6264H9.09055L7.20887 21.8856C7.00176 22.2443 6.54307 22.3672 6.18435 22.1601C5.82563 21.953 5.70272 21.4943 5.90983 21.1356L7.80443 17.854L6.13922 14.9698H2.35001C1.93579 14.9698 1.60001 14.634 1.60001 14.2198C1.60001 13.8056 1.93579 13.4698 2.35001 13.4698H6.13922L8.03387 10.1883C8.16784 9.95625 8.41543 9.8133 8.68337 9.8133L12.4725 9.81324L14.3672 6.53168C14.5011 6.29963 14.7487 6.15668 15.0167 6.15668H18.8059L20.7005 2.87513C20.9076 2.51641 21.3663 2.3935 21.725 2.60061ZM12.4726 11.3132L9.11639 11.3133L7.43826 14.2198L9.11639 17.1264H12.4726L14.1507 14.2199L12.4726 11.3132Z",
		fill: "currentColor"
	})
});
export { SvgIconMolecule as ReactComponent };
